module.exports = __webpack_public_path__ + "static/rocket-84e03114ae6d0516892ec2083e4c0866.png";